import { render } from "./TabsPage.vue?vue&type=template&id=451a2590&ts=true"
import script from "./TabsPage.vue?vue&type=script&lang=ts"
export * from "./TabsPage.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/jiunjyechin/PhpstormProjects/Zenship/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__